module.exports = __webpack_public_path__ + "img/8.a30ebd69.jpg";